
export const dataLengths = {
  '14d': '14d',
  '30d': '30d',
  '1m': '1m',
  '90d': '90d',
  '2m': '2m',
  '6m': '6m',
  '12m': '12m',
  '24m': '24m',
  '36m': '36m',
};

